import { actions } from '../../store/reducers/analysis';

export const supportedNamespaces = {
  cadd: [
    'scp', 'kyc', 'dd', 'scl',
  ],
  pme: [
    'scp', 'scl', 'kyc',
  ],
  tif: [
    'scp', 'scl', 'kyc', 'dd', 'mine-operators', 'amp', 'programs',
  ],
};

export const allActions = {
  kyc: actions.KycFetchRequest,
  programs: actions.ProgramsFetchReqeust,
  scp: actions.ScpFetchReqeust,
  'mine-operators': actions.MineOperatorsFetchReqeust,
  amp: actions.AmpFetchReqeust,
  dd: actions.DdFetchReqeust,
  scl: actions.SclFetchRequest,
};

export const clearActions = {
  kyc: actions.KycClearComponent,
  programs: actions.ProgramsClearComponent,
  scp: actions.ScpClearComponent,
  'mine-operators': actions.MineOperatorsClearComponent,
  amp: actions.AmpClearComponent,
  dd: actions.DdClearComponent,
  scl: actions.SclClearComponent,
};

export const sourceChangedActions = {
  scp: actions.ScpSourcesChanged,
  programs: actions.ProgramsSourcesChanged,
  'mine-operators': actions.MineOperatorsSourcesChanged,
  amp: actions.AmpSourcesChanged,
  scl: actions.SclSourcesChanged,
};
